/* eslint-disable react/no-danger */
/* eslint-disable react/no-array-index-key */
import * as React from 'react';

import { Modal } from '@olist/design-system';

import { ModalBody } from './modal-rules.styles';

interface ModalProps {
  isOpen: boolean;
  onClose: () => void;
  modalTitle: string;
  modalCostTitle: string;
  modalExplanations: any[];
  modalCosts: any[];
  modalLink: any;
}

const ModalRules = ({
  isOpen,
  modalCostTitle,
  modalCosts,
  modalExplanations,
  modalLink,
  modalTitle,
  onClose,
}: ModalProps) => {
  return (
    <Modal
      isOpen={isOpen}
      onClose={onClose}
      title={modalTitle}
      size="large"
      body={
        <ModalBody>
          <div className="modal-explanation">
            {modalExplanations.map(({ content }, index) => {
              return (
                <div className="explanation" key={`explanation-${index}`}>
                  <div
                    dangerouslySetInnerHTML={{
                      __html: content,
                    }}
                  />
                </div>
              );
            })}
          </div>
          <div className="costs">
            <div className="costs-title">
              <div
                dangerouslySetInnerHTML={{
                  __html: modalCostTitle,
                }}
              />
            </div>
            <div className="costs-content">
              {modalCosts.map(({ content }, index) => {
                return (
                  <div className="costs-item" key={`costs-item-${index}`}>
                    <div
                      dangerouslySetInnerHTML={{
                        __html: content,
                      }}
                    />
                  </div>
                );
              })}
            </div>
          </div>

          <div className="modal-link">
            <a href={modalLink.link} target="_blank" rel="noreferrer">
              {modalLink.title}
            </a>
          </div>
        </ModalBody>
      }
    />
  );
};

export { ModalRules };
